import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { moduletracking } from "../../Wyanoke/ModuleTracking";
import { PageContext } from "../../service/PageContext";

export class CmeActivityRecoCards extends Component {

  constructor(element: HTMLElement, context: PageContext) {
    super(element, context);

    void this.loadRecommendedCards();
  }

  private async loadRecommendedCards(): Promise<void> {
    const context = this._pageContext;
    if (!context) {
      throw new Error("No page context");
    }

    const service = context.recommendedService;
    if (!service) {
      throw new Error("No recommended service");
    }

    const listingViewName = this._element.dataset.viewDisplay;

    if (listingViewName === undefined) {
      throw new Error("No recommended service");
    }

    const myCme = await service.getReco(listingViewName);
    if (!myCme) {
      throw new Error("No recommended results");
    }

    this._element.innerHTML = myCme.cards;
    await context.componentFactory.loadComponents(this._element);
    moduletracking.AjaxTrackLinks(this._element,"Recommended");

    var cardItems = this._element.querySelectorAll(".save");
    cardItems.forEach(element => {
      element.addEventListener("keydown", function(e) {
        let ke = e as KeyboardEvent;
        let htmlElem = element as HTMLElement;
        if (ke.key === 'Enter') {
          htmlElem.click();
        }
      });
    });
  }

}

ComponentFactory.registerComponent("CmeActivityRecoCards",
CmeActivityRecoCards);
